import React from 'react';
import WName from '../../WName';
import PL from '../../problems/ProblemLink';
import QL from '../../faq/QuestionLink';
import LRL from '../../longreads/LongReadLink';
import AL from '../../angles/AngleLink';
import NW from '../../neologisms/NewWord';
import OML from '../OrMaybeLink';
import {TLDR, E1} from '../../common';

// STORIES

import {heaven1} from './heaven1';

const allStories = [
  heaven1,
];

export const stories = {
  name: "stories",
  alternatives: "s",
  // 'prelude' will always be 'Or maybe…'
  header: <span>
    What if we use <i>stories</i> as a way to <E1 noNW /> and <i>understand</i> <WName noNW />
  </span>,
  outside: <span>
    <TLDR />: <WName cap /> is <OML name="monsters">fiendishly</OML> <PL>hard</PL> to <E1 />, and (<LRL name="dumb it down">frankly</LRL>) to <i><LRL>understand</LRL></i>.
  </span>,
  preview: <div className="or-maybe-preview">
    <p>So here are fragments of the ‘<PL name="torment">TormentPods<sup>™</sup></PL>’ that some of the <NW>zyzzyvas</NW> were making to try to <i><LRL>connect</LRL></i> with you. Not ‘<AL>YOU</AL><sup>™</sup>’ the <NW>MNS system</NW> <AL name="freedom">puppet</AL>, but ‘<AL>you</AL>’ the actual <NW>POC</NW> (or, at least, <NW>POCA</NW>).</p>
  </div>, 
/*  text: <div className="or-maybe-text">
  </div>, */
  sublist: allStories,
};


